import Page from "../Common/Page";
import React from "react";
import {
  Table,
  Form,
  Button,
  Row,
  Col,
  Select,
  Space,
  Modal,
  Popconfirm,
  message,
} from "antd";
import { JudgmentUnitSelecter } from "../Components/JudgmentUnitSelecter";
import { http } from "../Common/http";
import { AuthContext } from "../Auth/Auth";
import { AllocationButton, AllocationUser } from "./AllocationButton";
import { AllocationUserSearchPage } from "./AllocationUserSearchPage";
import { Messages } from "../Common/ValidateMessages";
import { getSubjectOptions, getTeacherOptions } from "../Common/Utils";
import { CommonMasterSelect } from "../Components/CommonMasterSelect";

const { Option } = Select;

interface SelectOptionData {
  id: string;
  name: string;
}
interface StateType {
  defaultFy: string;
  subjectOptions: SelectOptionData[];
  teacherOptions: SelectOptionData[];
  selectedAllocationButton: number[];
  // page: number;
  datas: any[];
  allocatedRecordCount: number;
  examinationSubject: any;
  userDatas: AllocationUser[];
  userSearchVisible: boolean;
  subject: string;
  allocationChanged: boolean;
}
export class AllocationPage extends React.Component<any, StateType> {
  static contextType = AuthContext;
  private _page: React.RefObject<Page>;
  // private _table: React.RefObject<any>;
  // private _pageSize = 10;
  // _allocationButtons: any[];

  constructor(props: any, context) {
    super(props, context);
    this._page = React.createRef<Page>();
    // this._table = React.createRef<any>();
    // this._allocationButtons = [];
    this.state = {
      defaultFy: context.user.currentYear.toString(),
      subjectOptions: [],
      teacherOptions: [],
      selectedAllocationButton: [-1, -1],
      userSearchVisible: false,
      // page: 1,

      datas: [],
      allocatedRecordCount: 0,
      examinationSubject: undefined,
      userDatas: [],
      subject: "",
      allocationChanged: false,
    };
  }
  async componentDidMount() {
    const teacherOptions = await getTeacherOptions(this.context.accessToken);
    this.setState({
      teacherOptions: teacherOptions,
    });
  }

  // 一覧領域で採点担当者変更
  onAllocationButtonDataChange(
    row: number,
    col: number,
    newValue: AllocationUser | undefined
  ) {
    const cDatas = this.state.datas;
    cDatas[row].userList[col] = newValue;
    this.setState({
      datas: cDatas,
      allocatedRecordCount: this.calcAllocatedRecordCount(cDatas),
    });
  }

  // 一覧領域で採点担当者選択
  onAllocationButtionSelected(row: number, col: number) {
    this.setState({
      selectedAllocationButton: [row, col],
    });
  }

  onAllocationChangeAlert() {
    this.setState({
      allocationChanged: true,
    });
  }

  // 採点担当候補者領域で教員をダブルクリック
  onUserSelected(record: AllocationUser, rowIndex: number | undefined) {
    const cDatas = this.state.datas;
    const cRow = this.state.selectedAllocationButton[0];
    const cCol = this.state.selectedAllocationButton[1];
    const scoringNumOfPeople = this.state.examinationSubject.scoringNumOfPeople
      ? this.state.examinationSubject.scoringNumOfPeople
      : 0;
    if (cRow >= 0) {
      if (cDatas[cRow].userList != null) {
        for (let i = 0; i < cDatas[cRow].userList.length; i++) {
          if (
            cDatas[cRow].userList[i] &&
            cDatas[cRow].userList[i].userId === record.userId
          ) {
            message.error(Messages["ERR-066"]);
            return;
          }
        }
      }
      cDatas[cRow].userList[cCol] = record;
      this.setState({
        datas: cDatas,
        allocatedRecordCount: this.calcAllocatedRecordCount(cDatas),
      });

      let nRow: number;
      let nCol: number;
      for (nRow = cRow; nRow < cDatas.length; nRow++) {
        for (nCol = 0; nCol < scoringNumOfPeople; nCol++) {
          if (nRow === cRow && nCol <= cCol) {
            continue;
          }
          if (cDatas[nRow].userList[nCol] === undefined) {
            this.setState({
              selectedAllocationButton: [nRow, nCol],
            });
            const v = document.getElementsByClassName("ant-table-body")[0];
            const row: any =
              document.getElementsByClassName("ant-table-row")[0];
            if (v && row) {
              if (nRow > 5) {
                v.scrollTop = (nRow - 5) * row.offsetHeight;
              }
            }
            return;
          }
        }
      }
      if (nRow >= cDatas.length) {
        this.setState({
          selectedAllocationButton: [-1, -1],
        });
      }
    }
  }

  // 採点担当候補者領域
  userColumns = [
    {
      title: <div className="table-title">教員名前</div>,
      key: "name",
      width: "75%",
      render: (value: any, item: AllocationUser, index: number) =>
        `${item.sei} ${item.mei}`,
    },
    {
      title: "",
      key: "action",
      width: "20%",
      render: (value: any, item: AllocationUser, index: number) => (
        <Button
          type="link"
          onClick={() => {
            this.onDeleteAllocationCandidate(index);
          }}
        >
          除外
        </Button>
      ),
    },
  ];

  // 一覧領域
  columnsInit = [
    {
      title: () =>
        this.state.examinationSubject === undefined ||
        this.state.examinationSubject.groupCreationRequiredFlag !== "1" ? (
          <div className="table-title">受験番号</div>
        ) : (
          <div className="table-title">グループNO</div>
        ),
      dataIndex: "applicantNo",
      key: "applicantNo",
      width: "10%",
    },
    {
      title: () =>
        this.state.examinationSubject === undefined ||
        this.state.examinationSubject.groupCreationRequiredFlag !== "1" ? (
          <div className="table-title">氏名</div>
        ) : (
          <div className="table-title">志願者人数</div>
        ),
      dataIndex: "applicantName",
      key: "applicantName",
      width: "10%",
    },
    {
      title: <div className="table-title">採点担当者1</div>,
      key: "grader1",
      width: "10%",
      render: (value: any, item: any, index: number) => (
        <AllocationButton
          value={
            item.userList !== null && item.userList.length > 0
              ? item.userList[0]
              : undefined
          }
          isSel={
            this.state.selectedAllocationButton[0] === index &&
            this.state.selectedAllocationButton[1] === 0
              ? true
              : false
          }
          oldStatus={
            item.oldUserList &&
            item.oldUserList !== null &&
            item.oldUserList.length > 0
              ? item.oldUserList[0].scoringStatus
              : undefined
          }
          onChange={(newValue) =>
            this.onAllocationButtonDataChange(index, 0, newValue)
          }
          onSelect={() => this.onAllocationButtionSelected(index, 0)}
          onChangeAlert={() => this.onAllocationChangeAlert()}
        />
      ),
      shouldCellUpdate: (record, prevRecord) => {
        return true;
      },
    },
    {
      title: <div className="table-title">採点担当者2</div>,
      key: "grader2",
      width: "10%",
      render: (value: any, item: any, index: number) => (
        <AllocationButton
          value={
            item.userList !== null && item.userList.length > 1
              ? item.userList[1]
              : undefined
          }
          isSel={
            this.state.selectedAllocationButton[0] === index &&
            this.state.selectedAllocationButton[1] === 1
              ? true
              : false
          }
          oldStatus={
            item.oldUserList &&
            item.oldUserList !== null &&
            item.oldUserList.length > 1
              ? item.oldUserList[1].scoringStatus
              : undefined
          }
          onChange={(newValue) =>
            this.onAllocationButtonDataChange(index, 1, newValue)
          }
          onSelect={() => this.onAllocationButtionSelected(index, 1)}
          onChangeAlert={() => this.onAllocationChangeAlert()}
        />
      ),
      shouldCellUpdate: (record, prevRecord) => {
        return true;
      },
    },
    {
      title: <div className="table-title">採点担当者3</div>,
      key: "grader3",
      width: "10%",
      render: (value: any, item: any, index: number) => (
        <AllocationButton
          value={
            item.userList !== null && item.userList.length > 2
              ? item.userList[2]
              : undefined
          }
          isSel={
            this.state.selectedAllocationButton[0] === index &&
            this.state.selectedAllocationButton[1] === 2
              ? true
              : false
          }
          oldStatus={
            item.oldUserList &&
            item.oldUserList !== null &&
            item.oldUserList.length > 2
              ? item.oldUserList[2].scoringStatus
              : undefined
          }
          onChange={(newValue) =>
            this.onAllocationButtonDataChange(index, 2, newValue)
          }
          onSelect={() => this.onAllocationButtionSelected(index, 2)}
          onChangeAlert={() => this.onAllocationChangeAlert()}
        />
      ),
      shouldCellUpdate: (record, prevRecord) => {
        return true;
      },
    },
    {
      title: <div className="table-title">採点担当者4</div>,
      key: "grader4",
      width: "10%",
      render: (value: any, item: any, index: number) => (
        <AllocationButton
          value={
            item.userList !== null && item.userList.length > 3
              ? item.userList[3]
              : undefined
          }
          isSel={
            this.state.selectedAllocationButton[0] === index &&
            this.state.selectedAllocationButton[1] === 3
              ? true
              : false
          }
          oldStatus={
            item.oldUserList &&
            item.oldUserList !== null &&
            item.oldUserList.length > 3
              ? item.oldUserList[3].scoringStatus
              : undefined
          }
          onChange={(newValue) =>
            this.onAllocationButtonDataChange(index, 3, newValue)
          }
          onSelect={() => this.onAllocationButtionSelected(index, 3)}
          onChangeAlert={() => this.onAllocationChangeAlert()}
        />
      ),
      shouldCellUpdate: (record, prevRecord) => {
        return true;
      },
    },
    {
      title: <div className="table-title">採点担当者5</div>,
      key: "grader5",
      width: "10%",
      render: (value: any, item: any, index: number) => (
        <AllocationButton
          value={
            item.userList !== null && item.userList.length > 4
              ? item.userList[4]
              : undefined
          }
          isSel={
            this.state.selectedAllocationButton[0] === index &&
            this.state.selectedAllocationButton[1] === 4
              ? true
              : false
          }
          oldStatus={
            item.oldUserList &&
            item.oldUserList !== null &&
            item.oldUserList.length > 4
              ? item.oldUserList[4].scoringStatus
              : undefined
          }
          onChange={(newValue) =>
            this.onAllocationButtonDataChange(index, 4, newValue)
          }
          onSelect={() => this.onAllocationButtionSelected(index, 4)}
          onChangeAlert={() => this.onAllocationChangeAlert()}
        />
      ),
      shouldCellUpdate: (record, prevRecord) => {
        return true;
      },
    },
  ];
  columns = this.columnsInit;

  // 検索ボタン押す
  onFinish = async (values: any) => {
    // console.log("search:", values);
    try {
      this._page.current?.setState({ isPageLoading: true });
      const searchData = {
        Fy: this.state.defaultFy,
        JudgementUnitId: values.judgmentUnit ? values.judgmentUnit : null,
        ExaminationSubjectId: values.subject ? values.subject : null,
        UserId: values.teacher ? values.teacher : null,
      };
      const result = await http<any, any>({
        path: "/ScoreAllocation/searchapplicant",
        method: "post",
        body: searchData,
        accessToken: this.context.accessToken,
      });
      if (result.ok && result.body) {
        if (result.body.errorType === 0) {
          const scoringNumOfPeople = result.body.examinationSubject
            .scoringNumOfPeople
            ? result.body.examinationSubject.scoringNumOfPeople
            : 0;
          this.columns = this.columnsInit.slice(0, scoringNumOfPeople + 2);
          this.setState(
            {
              examinationSubject: result.body.examinationSubject,
            },
            () => {
              this.setState({
                datas: result.body.applicantScoringAllocationList,
                allocatedRecordCount: this.calcAllocatedRecordCount(
                  result.body.applicantScoringAllocationList,
                  scoringNumOfPeople
                ),
                userDatas: result.body.allocationUserList,
                allocationChanged: false,
              });
            }
          );
        } else if (result.body.errorType === 1) {
          message.error(Messages["ERR-067"]);
          this.setState(
            {
              examinationSubject: result.body.examinationSubject,
            },
            () => {
              this.setState({
                datas: [],
                allocatedRecordCount: 0,
                userDatas: [],
                allocationChanged: false,
              });
            }
          );
        } else if (result.body.errorType === 2) {
          message.error(
            `${result.body.examinationSubject.seq - 1}${Messages["ERR-068"]}`
          );
          this.setState(
            {
              examinationSubject: result.body.examinationSubject,
            },
            () => {
              this.setState({
                datas: [],
                allocatedRecordCount: 0,
                userDatas: [],
                allocationChanged: false,
              });
            }
          );
        }
      }
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      console.log(error);
      this._page.current?.setState({ isPageLoading: false });
      this.setState(
        {
          examinationSubject: undefined,
        },
        () => {
          this.setState({
            datas: [],
            allocatedRecordCount: 0,
            userDatas: [],
            allocationChanged: false,
          });
        }
      );
    }
  };

  // 採点担当者登録ボタン押す
  onRegister = async () => {
    try {
      this._page.current?.setState({ isPageLoading: true });
      const postData = {
        ExaminationSubjectId:
          this.state.examinationSubject.examinationSubjectId,
        ApplicantScoringAllocationList: this.state.datas,
      };
      const result = await http<any, any>({
        path: "/ScoreAllocation/savescoreallocation",
        method: "post",
        body: postData,
        accessToken: this.context.accessToken,
      });

      if (result.ok && result.body?.result === "1") {
        // 保存成功
        message.info(Messages["MSG-008"]);
      } else {
        // 失敗
        message.error(Messages["ERR-091"]);
      }
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      console.log(error);
      this._page.current?.setState({ isPageLoading: false });
      message.error(Messages["ERR-020"]);
    }
  };

  onFyChange = (newValue) => {
    this.setState({
      defaultFy: newValue.value,
    });
  };

  // 判定単位変更
  onJudgmentUnitSelected = async (record: any) => {
    // console.log("Success:", record);
    if (
      record &&
      record.fyJudgementUnitId &&
      record.fyJudgementUnitId.length > 0
    ) {
      const subjectOptions = await getSubjectOptions(
        this.context.accessToken,
        record.fyJudgementUnitId,
        undefined,
        "1",
        undefined
      );
      this.setState({
        subjectOptions: subjectOptions,
        subject: "",
        datas: [],
        allocatedRecordCount: 0,
        userDatas: [],
        allocationChanged: false,
      });
    } else {
      this.setState({
        subjectOptions: [],
        subject: "",
        datas: [],
        allocatedRecordCount: 0,
        userDatas: [],
        allocationChanged: false,
      });
    }
  };

  // 科目変更
  onSubjectChanged = (newValue) => {
    this.setState({
      subject: newValue,
      datas: [],
    });
  };

  // 採点担当候補者選択ボタン押す
  onUserSearchClick = (event) => {
    this.setState({
      userSearchVisible: true,
    });
  };

  // 採点担当候補者変更
  onChangeAllocationCandidate = (selectUsers: AllocationUser[]) => {
    this.setState({
      userSearchVisible: false,
    });
    if (selectUsers !== null && selectUsers.length > 0) {
      const userDatas = this.state.userDatas;
      const userDatasCount = userDatas.length;
      for (let i = 0; i < selectUsers.length; i++) {
        let existed = false;
        for (let j = 0; j < userDatasCount; j++) {
          if (selectUsers[i].userId === userDatas[j].userId) {
            existed = true;
            break;
          }
        }
        if (!existed) {
          userDatas.push(selectUsers[i]);
        }
      }
      this.setState({
        userDatas: [...userDatas],
      });
    }
  };

  // 採点担当候補者除外
  onDeleteAllocationCandidate = (deleteUserIndex: number) => {
    const datas = this.state.datas;
    const userDatas = this.state.userDatas;
    for (let i = 0; i < datas.length; i++) {
      if (datas[i].userList != null) {
        for (let j = 0; j < datas[i].userList.length; j++) {
          if (
            datas[i].userList[j].userId === userDatas[deleteUserIndex].userId
          ) {
            message.error(Messages["ERR-069"]);
            return;
          }
        }
      }
    }

    userDatas.splice(deleteUserIndex, 1);
    this.setState({
      userDatas: [...userDatas],
    });
  };

  calcAllocatedRecordCount = (
    datas: any[],
    scoringNumOfPeople: number = -1
  ) => {
    let allocatedRecordCount = 0;
    if (scoringNumOfPeople === -1) {
      scoringNumOfPeople = this.state.examinationSubject.scoringNumOfPeople;
    }
    if (datas !== undefined) {
      for (let i = 0; i < datas.length; i++) {
        if (
          datas[i].userList !== undefined &&
          datas[i].userList.length === scoringNumOfPeople
        ) {
          let addAllocatedCount = 1;
          for (let j = 0; j < datas[i].userList.length; j++) {
            if (
              datas[i].userList[j] === undefined ||
              datas[i].userList[j] === null
            ) {
              addAllocatedCount = 0;
              break;
            }
          }
          allocatedRecordCount += addAllocatedCount;
        }
      }
    }
    return allocatedRecordCount;
  };

  render(): React.ReactNode {
    return (
      <Page ref={this._page} title="採点担当登録">
        <div className="data_content">
          <Form
            colon={false}
            labelCol={{ span: 8 }}
            layout="horizontal"
            labelAlign="left"
            className="search_form"
            name="searchForm"
            onFinish={this.onFinish}
            initialValues={{
              fy: { value: this.state.defaultFy },
            }}
            fields={[{ name: "subject", value: this.state.subject }]}
          >
            <Row>
              <Col span={6}>
                <Form.Item
                  label="入試年度"
                  name="fy"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <CommonMasterSelect
                    allowClear={false}
                    masterType={31}
                    onChange={this.onFyChange}
                  />
                </Form.Item>
              </Col>
              <Col span={18}>
                <Form.Item
                  label="判定単位"
                  name="judgmentUnit"
                  labelCol={{ span: 2 }}
                  rules={[{ required: true }]}
                >
                  <JudgmentUnitSelecter
                    width={500}
                    defaultFy={this.state.defaultFy}
                    onDataSelect={this.onJudgmentUnitSelected}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={6}>
                <Form.Item
                  label="科目"
                  name="subject"
                  rules={[{ required: true }]}
                >
                  <Select
                    style={{ width: 160 }}
                    allowClear={false}
                    onChange={this.onSubjectChanged}
                  >
                    {this.state.subjectOptions.length > 0 &&
                      this.state.subjectOptions.map((data: any) => (
                        <Option key={data.id} value={data.id}>
                          {data.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="採点担当"
                  name="teacher"
                  labelCol={{ span: 3 }}
                >
                  <Select allowClear={true} style={{ width: 160 }}>
                    {this.state.teacherOptions.length > 0 &&
                      this.state.teacherOptions.map((data: any) => (
                        <Option key={data.id} value={data.id}>
                          {data.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    表示
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <div style={{ width: "100%" }}>
            <Space direction="vertical" style={{ width: "75%" }}>
              <ul className="resultCount">
                <li className="grey">
                  件数<span>{this.state.datas.length}</span>
                </li>
                <li className="blue">
                  割り振り済<span>{this.state.allocatedRecordCount}</span>
                </li>
              </ul>
              <Table
                rowKey={(record: any) => record.applicantId}
                bordered
                pagination={false}
                showSorterTooltip={false}
                columns={this.columns}
                dataSource={this.state.datas}
                scroll={{ y: "calc(100vh - 350px)" }}
              />
              <Popconfirm
                disabled={this.state.datas.length === 0}
                title={
                  this.state.allocationChanged
                    ? Messages["CON-033"]
                    : Messages["CON-018"]
                }
                okText="はい"
                cancelText="いいえ"
                onConfirm={() => this.onRegister()}
              >
                <Button
                  disabled={this.state.datas.length === 0}
                  type="primary"
                  style={{
                    float: "right",
                    marginRight: "20px",
                    marginTop: "10px",
                  }}
                >
                  採点担当者登録
                </Button>
              </Popconfirm>
            </Space>

            <Space
              direction="vertical"
              style={{ width: "24%", float: "right" }}
            >
              <Button type="primary" onClick={this.onUserSearchClick}>
                採点担当候補者選択
              </Button>
              <Table
                rowKey={(record: any) => record.userId}
                bordered
                pagination={false}
                showSorterTooltip={false}
                columns={this.userColumns}
                dataSource={this.state.userDatas}
                scroll={{ y: "calc(100vh - 350px)" }}
                onRow={(record, rowIndex) => {
                  return {
                    onClick: (event) => {}, // click row
                    onDoubleClick: (event) => {
                      this.onUserSelected(record, rowIndex);
                    }, // double click row
                    onContextMenu: (event) => {}, // right button click row
                    onMouseEnter: (event) => {}, // mouse enter row
                    onMouseLeave: (event) => {}, // mouse leave row
                  };
                }}
              />
            </Space>
          </div>
        </div>
        <Modal
          title="採点担当候補者選択"
          maskClosable={false}
          centered
          visible={this.state.userSearchVisible}
          // onOk={() => setVisible(false)}
          onCancel={() => this.setState({ userSearchVisible: false })}
          width={1200}
          footer={null}
        >
          <AllocationUserSearchPage
            onChange={this.onChangeAllocationCandidate}
            existedUsers={this.state.userDatas}
          />
          {/* {qpage} */}
        </Modal>
      </Page>
    );
  }
}
